import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useEffect } from "react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (params.get("verificado") === "1") {
      toast.success("¡Cuenta verificada! Inicia sesión con tu contraseña.");
    }
  }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Sesión iniciada");
      navigate("/");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen flex bg-[#F7F8FA]">
      <div className="hidden lg:flex w-1/2 relative bg-[#0E2A47]">
        <img
          src="https://images.unsplash.com/photo-1551884171-004163219904?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt="Control de calidad alimentaria"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="relative z-10 flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-2">
            <ShieldCheck className="text-[#FF5625]" size={32} />
            <div className="leading-none">
              <span className="font-black text-2xl tracking-tighter">AuditReady<span className="text-[#FF5625]">.</span></span>
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/50 mt-1">by Agentik</div>
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-[#FF5625] mb-4">Camino IFS</div>
            <h1 className="text-4xl font-black tracking-tighter leading-tight">
              Certificación IFS Food v8 de forma progresiva
            </h1>
            <p className="mt-4 text-white/70 max-w-md">
              Gestión documental, análisis de gaps, scoring de readiness y trazabilidad completa
              para empresas alimentarias.
            </p>
          </div>
          <div className="text-xs text-white/40">Núcleo Agentik · Multi-tenant seguro</div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="lg:hidden mb-8">
            <div className="flex items-center gap-2">
              <ShieldCheck className="text-[#FF5625]" size={28} />
              <span className="font-black text-xl tracking-tighter text-[#0E2A47]">AuditReady<span className="text-[#FF5625]">.</span></span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#0E2A47]/40 mt-1 ml-9">by Agentik</div>
          </div>
          <h2 className="text-2xl font-bold tracking-tight text-[#0E2A47]">Iniciar sesión</h2>
          <p className="text-sm text-[#0E2A47]/60 mt-1 mb-8">Acceda a su panel de cumplimiento IFS.</p>

          <div className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-xs font-bold uppercase tracking-wider text-[#0E2A47]/60">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                required data-testid="login-email" className="mt-1.5" placeholder="usuario@empresa.com" />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs font-bold uppercase tracking-wider text-[#0E2A47]/60">Contraseña</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required data-testid="login-password" className="mt-1.5" placeholder="••••••••" />
            </div>
          </div>

          <Button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full mt-8 bg-[#FF5625] hover:bg-[#E0451A] text-white font-semibold active:scale-[0.98] transition-transform">
            {loading ? "Accediendo…" : "Acceder"}
          </Button>

          <div className="mt-4 text-center">
            <Link to="/recuperar" className="text-sm text-[#0E2A47]/60 hover:text-[#FF5625] font-medium" data-testid="link-recuperar">
              ¿Olvidaste tu contraseña?
            </Link>
          </div>

          <div className="mt-6 text-sm text-[#0E2A47]/60 text-center border-t border-[#E2E8F0] pt-6">
            ¿No tienes cuenta? <Link to="/registro" className="text-[#FF5625] font-semibold" data-testid="link-registro">Empieza gratis 14 días</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
